import { defineStore } from 'pinia';

export const useCommonStore = defineStore('common', {
  state: () => ({
    loading: 0,
    transitioning: false,
    layoutName: ''
  }),

  getters: {
    getLoading: (state) => state.loading,
    getTransitioning: (state) => state.transitioning,
    getLayout: (state) => state.layoutName
  },

  actions: {
    setLayout(layout: string) {
      this.layoutName = layout;
    },
    
    setLoading(loading: number) {
      this.loading = loading;
    },
    
    increaseLoading() {
      if (this.loading < 0) {
        this.loading = 0;
      }
      this.loading = this.loading + 1;
    },
    
    decreaseLoading() {
      if (this.loading <= 0) {
        this.loading = 0;
      }
      else this.loading = this.loading - 1;
    },
    

    setTransitionStatus(transitioning: boolean) {
      this.transitioning = transitioning;
    }
  }
}); 